// Main sidebaar permissions
export const CLIENT_REPORTING = 'client_reporting-read';
export const CLIETN_COMPANIES = 'client_companies-read';
export const CLIENT_CASES = 'client_cases-read';
export const CLIENT_CASES_CREATE = 'client_cases-create';
export const CLIENT_CHATS = 'client_chats-read';
export const CLIENT_PROJECTS = 'client_projects-read';
export const CLIENT_CASES_UPDATE = 'client_cases-update';
export const CLIENT_PLANNING = 'client_planning-read';
export const CLIENT_QUOTATIONS = 'client_quotations-read';
export const CLIENT_INVOICES = 'client_invoices-read';
export const CLIENT_USERS = 'client_users-read';
export const CLIENT_ORDERS = 'client_orders-read';
export const CLIENT_ORDERS_CREATE = 'client_order-create';
export const APPROVALS = 'approvals-read';
export const TESTING = 'testing-read';

// mindtime portal permissoin in main sidebar
export const CLIENT_DASHBOARD = 'client_dashboard-read';
export const CLIETN_HOME = 'client_home-read';
export const CLIENT_BACKUPS = 'client_backups-read';
export const CLIENT_EXPLORER = 'client_explorer-read';
export const CLIENT_BACKUP_USERS = 'client_backup_users-read';
export const CLIENT_PRICES = 'client_prices-read';
export const CLIENT_LISTS = 'client_lists-read';
export const CLIENT_HISTORY = 'client_history-read';
export const CLIENT_SUPPORT = 'client_support-read';
export const CLIENT_BACKUP_PORTAL = 'client_backup_portal-read';
export const CLIENT_MINDTIME_SECURITY = 'client_mindtime_security-read';

// Mindtime Security in main sidebar and these are the Child routes groups
export const CLIENT_MINDTIME_SECURITY_EDR = 'client_mindtime_security_edr-read';
export const CLIENT_MINDTIME_SECURITY_XDR = 'client_mindtime_security_xdr-read';
export const CLIENT_MINDTIME_SECURITY_SIEM = 'client_mindtime_security_siem-read';
export const CLIENT_MINDTIME_SECURITY_SSL_MANAGEMENT = 'client_mindtime_security_ssl_management-read';


// Security routes permissions in security EDR sidebar under mindtime-security group
export const CLIENT_EDR_SOC = 'client_edr_soc-read';
export const CLIENT_EDR_RESELLER_DASHBOARD = 'client_edr_reseller_dashboard-read';
export const CLIENT_EDR_SUB_ORG_DASHBOARD = 'client_edr_sub_org_dashboard-read';
export const CLIENT_EDR_CLIENTS = 'client_edr_clients-read';
export const CLIENT_EDR_ENDPOINTS = 'client_edr_endpoints-read';
export const CLIENT_EDR_ENDPOINTS_DEPLOY_AGENT = 'client_edr_endpoints_deploy_agent-create';
export const CLIENT_EDR_MALWARE_DETECTION = 'client_edr_malware_detection-read';
export const CLIENT_EDR_AUTOMATED_RESPONSE = 'client_edr_automated_response-read';
export const CLIENT_EDR_FILE_INTEGRITY_MONITORING = 'client_edr_file_integrity_monitoring-read';
export const CLIENT_EDR_THREAT_HUNTING = 'client_edr_threat_hunting-read';
export const CLIENT_EDR_VULNERABILITIES_DETECTION = 'client_edr_vulnerabilities_detection-read';
export const CLIENT_EDR_CONFIGURATION_ASSESSMENT = 'client_edr_configuration_assessment-read';
export const CLIENT_EDR_MITRE_ATTACK = 'client_edr_mitre_attack-read';








